import "kbw-countdown/dist/js/jquery.plugin";
import "kbw-countdown/dist/js/jquery.countdown";

// Initialize the product viewer functionality

// Wait for the DOM to be fully loaded before running the script
document.addEventListener('DOMContentLoaded', (): void => {
    // Get elements
    const styleContainer: HTMLElement | null = document.getElementById('style-list');
    const styleWrapper: HTMLElement | null = document.querySelector('.style-list-wrapper');
    const recContainer: HTMLElement | null = document.getElementById('rec-list');
    const recWrapper: HTMLElement | null = document.querySelector('.rec-list-wrapper');
    const similarContainer: HTMLElement | null = document.getElementById('similar-list');
    const similarWrapper: HTMLElement | null = document.querySelector('.similar-list-wrapper');

    if (styleContainer && styleWrapper) {
        // Create and append scroll arrow elements
        const leftArrow: HTMLDivElement = document.createElement('div');
        leftArrow.className = 'scroll-arrow scroll-arrow-left';
        styleWrapper.appendChild(leftArrow);

        const rightArrow: HTMLDivElement = document.createElement('div');
        rightArrow.className = 'scroll-arrow scroll-arrow-right';
        styleWrapper.appendChild(rightArrow);

        // Function to handle scroll position and update UI state
        const updateScrollState = (): void => {
            // Show/hide left fade and arrow based on scroll position
            if (styleContainer.scrollLeft > 10) {
                styleWrapper.classList.add('scrolled-down');
            } else {
                styleWrapper.classList.remove('scrolled-down');
            }

            // Check if scrolled to rightmost edge to hide right fade and arrow
            const isAtRight: boolean = styleContainer.scrollWidth - styleContainer.scrollLeft - styleContainer.clientWidth < 1;
            styleWrapper.classList.toggle('scrolled-end', isAtRight);
        };

        // Function to scroll left
        const scrollLeft = (): void => {
            // Scroll left by the width of 3 items (300px) with smooth animation
            styleContainer.scrollBy({
                left: -300,
                behavior: 'smooth'
            });
        };

        // Function to scroll right
        const scrollRight = (): void => {
            // Scroll right by the width of 3 items (300px) with smooth animation
            styleContainer.scrollBy({
                left: 300,
                behavior: 'smooth'
            });
        };

        // Add event listeners for scroll buttons
        leftArrow.addEventListener('click', scrollLeft);
        rightArrow.addEventListener('click', scrollRight);

        // Add scroll event listener to update UI state
        styleContainer.addEventListener('scroll', (e: Event): void => {
            e.preventDefault(); // Prevent default action
            e.stopPropagation();
            updateScrollState();
        });

        // Initial check for scroll position
        const checkInitialStyleScroll = (): void => {
            // Small delay to allow layout rendering, especially after resize
            setTimeout((): void => {
                updateScrollState();
            }, 50); // 50ms delay, adjust if needed
        };

        // Initial check
        checkInitialStyleScroll();
        // Also check after images have loaded (which can change content size)
        window.addEventListener('load', checkInitialStyleScroll);
        // Check after window resize as layout might change
        window.addEventListener('resize', checkInitialStyleScroll);
    }

    if (recContainer && recWrapper) {
        // Create and append scroll arrow elements
        const leftArrow: HTMLDivElement = document.createElement('div');
        leftArrow.className = 'scroll-arrow scroll-arrow-left';
        recWrapper.appendChild(leftArrow);

        const rightArrow: HTMLDivElement = document.createElement('div');
        rightArrow.className = 'scroll-arrow scroll-arrow-right';
        recWrapper.appendChild(rightArrow);

        // Function to handle scroll position and update UI state
        const updateScrollState = (): void => {
            // Show/hide left fade and arrow based on scroll position
            if (recContainer.scrollLeft > 10) {
                recWrapper.classList.add('scrolled-down');
            } else {
                recWrapper.classList.remove('scrolled-down');
            }

            // Check if scrolled to rightmost edge to hide right fade and arrow
            const isAtRight: boolean = recContainer.scrollWidth - recContainer.scrollLeft - recContainer.clientWidth < 1;
            recWrapper.classList.toggle('scrolled-end', isAtRight);
        };

        // Function to scroll left
        const scrollLeft = (): void => {
            // Scroll left by the width of 3 items (300px) with smooth animation
            recContainer.scrollBy({
                left: -300,
                behavior: 'smooth'
            });
        };

        // Function to scroll right
        const scrollRight = (): void => {
            // Scroll right by the width of 3 items (300px) with smooth animation
            recContainer.scrollBy({
                left: 300,
                behavior: 'smooth'
            });
        };

        // Add event listeners for scroll buttons
        leftArrow.addEventListener('click', scrollLeft);
        rightArrow.addEventListener('click', scrollRight);

        // Add scroll event listener to update UI state
        recContainer.addEventListener('scroll', (e: Event): void => {
            e.preventDefault(); // Prevent default action
            e.stopPropagation();
            updateScrollState();
        });

        // Initial check for scroll position
        const checkInitialStyleScroll = (): void => {
            // Small delay to allow layout rendering, especially after resize
            setTimeout((): void => {
                updateScrollState();
            }, 50); // 50ms delay, adjust if needed
        };

        // Initial check
        checkInitialStyleScroll();
        // Also check after images have loaded (which can change content size)
        window.addEventListener('load', checkInitialStyleScroll);
        // Check after window resize as layout might change
        window.addEventListener('resize', checkInitialStyleScroll);
    }

    if (similarContainer && similarWrapper) {
        // Create and append scroll arrow elements
        const leftArrow: HTMLDivElement = document.createElement('div');
        leftArrow.className = 'scroll-arrow scroll-arrow-left';
        similarWrapper.appendChild(leftArrow);

        const rightArrow: HTMLDivElement = document.createElement('div');
        rightArrow.className = 'scroll-arrow scroll-arrow-right';
        similarWrapper.appendChild(rightArrow);

        // Function to handle scroll position and update UI state
        const updateScrollState = (): void => {
            // Show/hide left fade and arrow based on scroll position
            if (similarContainer.scrollLeft > 10) {
                similarWrapper.classList.add('scrolled-down');
            } else {
                similarWrapper.classList.remove('scrolled-down');
            }

            // Check if scrolled to rightmost edge to hide right fade and arrow
            const isAtRight: boolean = similarContainer.scrollWidth - similarContainer.scrollLeft - similarContainer.clientWidth < 1;
            similarWrapper.classList.toggle('scrolled-end', isAtRight);
        };

        // Function to scroll left
        const scrollLeft = (): void => {
            // Scroll left by the width of 3 items (300px) with smooth animation
            similarContainer.scrollBy({
                left: -300,
                behavior: 'smooth'
            });
        };

        // Function to scroll right
        const scrollRight = (): void => {
            // Scroll right by the width of 3 items (300px) with smooth animation
            similarContainer.scrollBy({
                left: 300,
                behavior: 'smooth'
            });
        };

        // Add event listeners for scroll buttons
        leftArrow.addEventListener('click', scrollLeft);
        rightArrow.addEventListener('click', scrollRight);

        // Add scroll event listener to update UI state
        similarContainer.addEventListener('scroll', (e: Event): void => {
            e.preventDefault(); // Prevent default action
            e.stopPropagation();
            updateScrollState();
        });

        // Initial check for scroll position
        const checkInitialStyleScroll = (): void => {
            // Small delay to allow layout rendering, especially after resize
            setTimeout((): void => {
                updateScrollState();
            }, 50); // 50ms delay, adjust if needed
        };

        // Initial check
        checkInitialStyleScroll();
        // Also check after images have loaded (which can change content size)
        window.addEventListener('load', checkInitialStyleScroll);
        // Check after window resize as layout might change
        window.addEventListener('resize', checkInitialStyleScroll);
    }

}); // End DOMContentLoaded